import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { StockList, StocksFooter } from "./components";

const Header = (): JSX.Element => (
  <BoldText className={styles.groupTitle}>Склады, магазины</BoldText>
);

export const Stocks = (): JSX.Element => (
  <BaseLayout
    className={classNames("ml-2 mt-3 mb-3", styles.container)}
    header={<Header />}
    footer={<StocksFooter />}
  >
    <StockList />
  </BaseLayout>
);
